module.exports = __webpack_public_path__ + "img/commend2.c559ff22.png";